<template>
  <div>
  <a-drawer
      :title="title"
      :width="470"
      placement="right"
      :closable="false"
      @close="handleCancelParent"
      :visible="visible"
    >
    <div>
      <a-form :form="form">
        <a-form-item label="位置" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input
            type="hidden"
            v-decorator="['location', { rules: [{ required: true, message: '' }] }]"
          />
          <a-tooltip placement="topLeft" :title="currentLocation.address" arrow-point-at-center>
            <a-button
              class="marker-info__address"
              :class="[currentLocation.address ? 'btn-location-picker':'']"
              type="dashed"
              block
              @click="locationPickerVisible = true">
                <img class="location-img" src="/img/location1-1.png" />
                {{currentLocation.address ? currentLocation.address : '选择位置'}}
            </a-button>
          </a-tooltip>
        </a-form-item>
        <a-form-item label="名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-textarea v-decorator="['callout']" :placeholder="markerName" auto-size />
        </a-form-item>
        <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-textarea v-decorator="['label']" placeholder="请输入备注（地图上显示）" auto-size />
        </a-form-item>
        <a-form-item label="描述" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-textarea v-decorator="['desc']" placeholder="请输入描述（地图上不显示）" auto-size />
        </a-form-item>
        <a-form-item label="图标" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-radio-group v-decorator="['icon']" @change="handleChangeIcon">
            <a-radio-button
              v-for="icon in iconList"
              :value="icon" :key="icon">
              <img class="location-img" :src="'/img/' + icon" />
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="分组" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-decorator="['group']" placeholder="请输入分组名" auto-size />
          <div class="group-tags-wrapper" v-if="existingGroups && existingGroups.length">
            <a-tag
              v-for="group in existingGroups"
              :key="group"
              class="group-tag"
              @click="handleGroupTagClick(group)"
            >{{ group }}</a-tag>
          </div>
        </a-form-item>
      </a-form>
      <a-form-item
        class="btn-upload"
        label="图片"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }">
        <a-button @click="handleChooseFile"> <a-icon type="upload"/> 上传 </a-button>
      </a-form-item>
      <a-upload
        class="clearfix"
        accept="image/*"
        :customRequest="handleUpload"
        listType="picture-card"
        :fileList="fileList"
        @preview="handlePreview"
        @change="handleChange"
      >
        <a-button ref="uploadButton">上传</a-button>
      </a-upload>
      <a-modal
        :width="previewWidth"
        :visible="previewVisible"
        :footer="null"
        @cancel="previewVisible = false"
      >
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>

      <div
        :style="{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '10px 16px',
          textAlign: 'right',
          left: 0,
          background: '#fff',
          borderRadius: '0 0 4px 4px',
        }"
      >
        <a-button type="danger" class="delete-button" @click="handDelete">删除</a-button>
        <a-button style="marginRight: 8px" @click="handleCancelParent">
          取消
        </a-button>
        <a-button @click="handleOk" type="primary">
          确定
        </a-button>
      </div>

    </div>
  </a-drawer>
  <location-picker
    from="markerModal"
    :visible.sync="locationPickerVisible"
    :longitude="currentLocation.longitude"
    :latitude="currentLocation.latitude"
    @confirm="handleLocationResult">
  </location-picker>

  </div>
</template>

<script>
/* eslint-disable prefer-destructuring */
import Compressor from 'compressorjs';
import LocationPicker from '@/components/location-picker-2/index.vue';

export default {
  components: {
    LocationPicker,
  },
  props: {
    visible: Boolean,
    title: String,
    marker: Object,
    existingGroups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'coordinated' }),
      previewVisible: false,
      previewWidth: 520,
      previewImage: '',
      fileList: [
        // {
        //   uid: '-1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        // },
      ],
      iconList: ['location1-1.png', 'location1-2.png', 'location1-3.png', 'location1-4.png', 'location1-5.png', 'location1-6.png'],
      locationPickerVisible: false,
      markerName: '默认标记名称',
      currentLocation: {
        address: '',
        longitude: 116.397428,
        latitude: 39.90923,
      },
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    handleOk() {
      // this.handleCancelParent();
      const formData = this.form.getFieldsValue();
      this.marker.longitude = parseFloat(this.currentLocation.longitude);
      this.marker.latitude = parseFloat(this.currentLocation.latitude);
      this.marker.name = formData.callout ? formData.callout : this.markerName;
      // eslint-disable-next-line max-len
      this.marker.originName = this.currentLocation.name ? this.currentLocation.name : this.marker.originName;
      this.marker.address = this.currentLocation.address;
      this.marker.labelContent = formData.label;
      this.marker.descContent = formData.desc;
      this.marker.iconPath = `/common/img/${formData.icon}`;
      this.marker.group = formData.group || '';
      // 新上传的文件id在response属性里
      this.marker.pictures = this.fileList.map(item => item.response || item.uid);
      this.$emit('confirm', this.marker);
      this.handleCancelParent();

      localStorage.setItem('lastMarkerIcon', formData.icon);
    },
    handleCancelParent() {
      this.$emit('update:visible', false);
    },
    handDelete() {
      this.handleCancelParent();
      this.$emit('delete', this.marker);
    },
    handleChangeIcon() {

    },
    handleGroupTagClick(group) {
      this.form.setFieldsValue({
        group,
      });
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
      const img = new Image();
      img.src = this.previewImage;
      img.onload = () => {
        let availWidth = document.body.offsetWidth;
        availWidth *= 0.8;
        if (img.width > availWidth) {
          this.previewWidth = availWidth;
        } else {
          // 左右 padding 24px，预留padding
          this.previewWidth = img.width + 48;
        }
      };
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    handleLocationResult(locationInfo) {
      this.$confirm({
        title: '',
        content: '是否覆盖地址和名称？',
        okText: '覆盖',
        cancelText: '不覆盖',
        onOk: () => {
          // 设置地址显示的内容，address、location是有用的
          this.currentLocation = {
            address: locationInfo.address,
            longitude: locationInfo.longitude,
            latitude: locationInfo.latitude,
          };
          // 设置表单绑定的名称
          this.form.setFieldsValue({
            callout: locationInfo.name,
          });
          // 设置默认名称
          this.markerName = locationInfo.name;
        },
        onCancel: () => {
          this.currentLocation.longitude = locationInfo.longitude;
          this.currentLocation.latitude = locationInfo.latitude;
        },
      });
    },
    handleChooseFile() {
      console.log(this.$refs.uploadButton);
      this.$refs.uploadButton.$el.click();
    },
    async handleUpload({ file, onProgress, onSuccess }) {
      // eslint-disable-next-line no-new
      new Compressor(file, {
        quality: 0.6,
        // 大于 2M 的 png 文件进行压缩
        convertSize: 2000000,
        success: async (result) => {
          const formData = new FormData();
          formData.append('file', result, result.name);
          const res = await this.$api.proxy.uploadfile(formData, {
            onUploadProgress: ({ total, loaded }) => {
              onProgress({ percent: Math.round(loaded / total * 100) }, file);
            },
          });

          onSuccess(res.data.data.file_list[0].fileid, result);
        },
        error: () => {
          this.$message.error('上传失败', 2000,
            () => {});
        },
      });
    },
    getMarkerIconName(iconPath) {
      const iconName = iconPath.replace('/common/img/', '');
      return iconName;
    },
  },
  watch: {
    async visible(newVal) {
      if (newVal) {
        // 先重置
        this.form.resetFields();
        this.markerName = '';
        this.currentLocation = {
          longitude: 116.397428,
          latitude: 39.90923,
          address: '',
        };
        this.fileList = [];

        await this.$nextTick();
        // 回显
        if (this.marker) {
          this.currentLocation = {
            address: this.marker.address,
            longitude: this.marker.longitude,
            latitude: this.marker.latitude,
          };
          this.markerName = this.marker.originName;
          this.form.setFieldsValue({
            callout: this.marker.name,
            label: this.marker.labelContent,
            desc: this.marker.descContent,
            icon: this.getMarkerIconName(this.marker.iconPath),
            group: this.marker.group || '',
          });
          console.log('====', this.marker);
          if (this.marker.pictures && this.marker.pictures.length) {
            console.log(this.marker.pictures, this.fileList);
            const res = await this.$api.proxy.batchdownloadfile(this.marker.pictures);
            const resFileList = res.data.data.file_list;
            this.fileList = resFileList.map(item => ({
              uid: item.fileid,
              name: item.fileid,
              status: 'done',
              url: item.download_url,
            }));
          }
        }
      }
    },
  },
};
</script>

<style scoped>
  /* you can make up upload button and sample style by using stylesheets */
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .btn-location-picker {
    text-align: left;
  }
  .location-img {
    height: 20px;
  }
  .btn-upload {
    margin-bottom: 12px;
  }

  * /deep/ .ant-upload {
    display: none;
  }

  .ant-radio-button-wrapper-checked {
    background-color: #f5f5f5;
  }

  .delete-button {
    float: left;
  }

  .marker-info__address {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .group-tags-wrapper {
    margin-top: 4px;
  }

  .group-tag {
    cursor: pointer;
    user-select: none;
  }

  .group-tag:hover {
    opacity: 0.8;
  }
</style>
